var React = require('react');

function LogoNickInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 39.3V23.67h7.81V39.3H0zm23.44 0L0 .24h7.81L23.44 26.8V.24L31.25 0v39.3h-7.81z","id":"a"}));
}

LogoNickInline.defaultProps = {"width":"31.25","height":"39.3","viewBox":"0 0 32 40","fill":"currentColor"};

module.exports = LogoNickInline;

LogoNickInline.default = LogoNickInline;
